<nz-layout class="travel-history-section">
  <nz-header>
  </nz-header>
  <nz-content>
    <app-travel-history />
  </nz-content>
</nz-layout>